// extracted by mini-css-extract-plugin
export var animationContainer = "_dz-0";
export var asteriskIcon = "_dz-8";
export var conversationLeftSection = "_dz-4";
export var conversationListItem = "_dz-3";
export var conversationMiddleSection = "_dz-5";
export var conversationRightSection = "_dz-6";
export var detailsContent = "_dz-1";
export var listContainer = "_dz-7";
export var modalContent = "_dz-2";